module.exports = __webpack_public_path__ + "static/media/bz_swiper_y.5a5a0bca.jpg";